import template from "./pricing-table-modal.html";

const PricingTableModalComponent = {
  bindings: {
    resolve: "<",
    dismiss: "&",
    close: "&",
  },
  template: template,
  controller: class PricingTableModalController {
    /* @ngInject */
    constructor($stateParams, $scope, SweetAlertService, $window) {
      this.SweetAlertService = SweetAlertService;
      this.$scope = $scope;
      this.$stateParams = $stateParams;
      this.$window = $window;
    }

    $onInit() {
      this.pricingTable = this.resolve.pricingTable;
      this.changePricingTable = this.resolve.onChangePricingTable;
      this.pricingTableInitial = angular.copy(this.pricingTable);
      this.existCostWithDifferentCurrency =
        this.resolve.existCostWithDifferentCurrency;
      this.updatedRatesLastDate = this.resolve.updatedRatesLastDate;
      this.areRatesUpdated = this.resolve.areRatesUpdated;
      this.updateRates = this.resolve.updateRates;
      this.pricingTableFormInvalid = false;
      this._managePressBrowserBackButton();
    }

    async onDismiss(fromPricingTable) {
      if (angular.equals(this.pricingTableInitial, this.pricingTable))
        this.dismiss({ $value: "cancel" });
      else {
        if (
          fromPricingTable &&
          this.pricingTableFormInvalid &&
          (await this.SweetAlertService.pricingTableIsWrong())
        )
          return;
        else if (!fromPricingTable && !this.pricingTableFormInvalid) {
          if (await this.SweetAlertService.pricingTableIsRight())
            this.onClose();
        } else if (!(await this.SweetAlertService.wantCancelPricingTable()))
          this.dismiss({ $value: "cancel" });
      }
    }

    onClose() {
      this.changePricingTable();
      this.close({ $value: true });
    }

    _managePressBrowserBackButton() {
      this.$scope.$on("$locationChangeStart", function (event, next, current) {
        event.preventDefault();
      });
      this.$window.onpopstate = async (e) => {
        if (!(await this.SweetAlertService.wantGoBackFromPricingTable()))
          this.dismiss({ $value: "cancel" });
      };
    }

    $onDestroy() {
      this.$scope.$on(
        "$locationChangeStart",
        function (event, next, current) {}
      );
      this.$window.onpopstate = function (e) {};
    }
  },
};

export default PricingTableModalComponent;
